module.exports = function() {
  return new Worker(__webpack_public_path__ + "908b57eb57754b3e976b.worker.js");
};